import { AppProviders } from '../providers/AppProviders'
import { AppRouter } from './AppRouter'
import { ErrorBoundary } from '@shared/components/ErrorBoundary'

function App(): JSX.Element {
  return (
    <ErrorBoundary>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ErrorBoundary>
  )
}

export default App
